/**
 * --- KONSEP: TAMPILAN KOTAK PESAN (NOTIFICATION MODAL) ---
 * File ini adalah desain visual untuk semua popup yang muncul di layar,
 * baik itu pesan Berhasil (Hijau), Gagal (Merah), atau Konfirmasi (Biru).
 */
import { useNotification } from "../../context/NotificationContext";

const NotificationModal = () => {
  const { notification, closeNotification } = useNotification();

  // Jika tidak ada pesan yang perlu ditampilkan, jangan munculkan apa-apa
  if (!notification.isOpen) return null;

  /**
   * LOGIKA: Menentukan Warna dan Ikon
   * Berdasarkan jenis pesan (error, confirm, atau success).
   */
  const getTypeStyles = () => {
    switch (notification.type) {
      case "error":
        return {
          icon: "error",
          iconClass: "text-error",
          bgClass: "bg-error-container/20",
          btnClass: "bg-error text-on-error",
        };
      case "confirm":
        return {
          icon: "help",
          iconClass: "text-tertiary",
          bgClass: "bg-tertiary-container/20",
          btnClass: "bg-tertiary text-on-tertiary",
        };
      case "warning":
        return {
          icon: "warning",
          iconClass: "text-amber-500",
          bgClass: "bg-amber-100/30",
          btnClass: "bg-amber-500 text-white",
        };
      default: // success (Berhasil)
        return {
          icon: "check_circle",
          iconClass: "text-primary",
          bgClass: "bg-primary-container/20",
          btnClass: "bg-primary text-on-primary",
        };
    }
  };

  const styles = getTypeStyles();

  // Tombol "Oke" atau "Lanjutkan"
  const handleConfirm = () => {
    if (notification.onConfirm) {
      notification.onConfirm();
    }
    closeNotification();
  };

  // Tombol "Batal"
  const handleCancel = () => {
    if (notification.onCancel) {
      notification.onCancel();
    }
    closeNotification();
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-on-surface/40 backdrop-blur-sm animate-fade-in">
      <div className="bg-surface-container-lowest w-full max-w-sm rounded-[28px] overflow-hidden shadow-2xl animate-scale-in border border-outline-variant/10">
        {/* BAGIAN ATAS (Ikon & Teks) */}
        <div
          className={`p-8 flex flex-col items-center text-center ${styles.bgClass}`}
        >
          <div
            className={`w-16 h-16 rounded-2xl flex items-center justify-center mb-4 bg-white shadow-sm border border-outline-variant/5`}
          >
            <span
              className={`material-symbols-outlined text-4xl ${styles.iconClass}`}
            >
              {styles.icon}
            </span>
          </div>

          <h3 className="font-headline text-2xl font-black text-on-surface tracking-tight mb-2">
            {notification.title}
          </h3>
          <p className="text-on-surface-variant font-medium leading-relaxed px-2">
            {notification.message}
          </p>
        </div>

        {/* BAGIAN BAWAH (Tombol Aksi) */}
        <div className="p-6 bg-surface-container-lowest flex gap-3">
          {/* Tampilkan tombol Batal hanya jika jenisnya adalah Konfirmasi */}
          {notification.type === "confirm" && (
            <button
              onClick={handleCancel}
              className="flex-1 py-3 px-6 rounded-2xl text-on-surface-variant font-bold text-sm hover:bg-surface-container transition-all uppercase tracking-wider"
            >
              Batal
            </button>
          )}
          <button
            onClick={handleConfirm}
            className={`flex-1 py-3 px-6 rounded-2xl font-bold text-sm shadow-lg shadow-black/5 hover:scale-[1.02] active:scale-[0.98] transition-all uppercase tracking-wider ${styles.btnClass}`}
          >
            {notification.type === "confirm" ? "Lanjutkan" : "Oke"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationModal;
